import { EDITOR_MODE } from "@pathwright/blocks-engine"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import React from "react"
import { isEmptyHTML, isMobile } from "../../utils"
import FlashcardAudio from "./FlashcardAudio"
import FlashcardHtml from "./FlashcardHtml"
import FlashcardImage from "./FlashcardImage"
import { DragSquare, FlashcardRemove, FlashcardSideWrapper } from "./ui"

const FlashcardSide = (props) => {
  const {
    cardIndex,
    side,
    DragHandle,
    sideName,
    children,
    removeFlashcard,
    onChangeAudio,
    mode
  } = props

  const [isHoverPlaying, setIsHoverPlaying] = React.useState(false)

  React.useEffect(() => {
    if (isHoverPlaying) {
      setIsHoverPlaying(false)
    }
  }, [sideName])

  const handleToggleHoverPlaying = (toggle) => (event) => {
    const { currentTarget } = event
    if (!currentTarget.classList.contains(sideName)) {
      console.log("Wrong side, aborting")
      return
    }

    if (!side.audio) return
    setIsHoverPlaying(toggle)
  }

  const handleClickSide = (event) => {
    if (
      // Suppress flip for text selection or link clicks.
      window.getSelection().toString().length > 0 ||
      event.target.closest("a") ||
      mode === EDITOR_MODE.EDIT
    ) {
      event.stopPropagation()
    }
    setIsHoverPlaying(false)
  }

  const mobile = isMobile()
  const mouseEvents = {
    onClick: handleClickSide,
    onMouseEnter: !mobile ? handleToggleHoverPlaying(true) : null,
    onMouseLeave: !mobile ? handleToggleHoverPlaying(false) : null
  }

  return (
    <FlashcardSideWrapper
      className={`Flashcard__side ${sideName} ${cardIndex}`}
      {...mouseEvents}
    >
      <FlashcardHtml
        {...props}
        applyOverlay={!!side.image && !isEmptyHTML(side.html)}
      />
      <FlashcardImage {...props} />
      {mode === EDITOR_MODE.EDIT && cardIndex > 0 && (
        <FlashcardRemove onImage={!!side.image} onClick={removeFlashcard}>
          <Pathicon icon="trash" className="EditModeIcon" size="1em" />
        </FlashcardRemove>
      )}
      <FlashcardAudio
        mode={mode}
        side={side}
        audio={side.audio}
        invertIcon={!!side.image}
        isHoverPlaying={isHoverPlaying}
        onChangeAudio={onChangeAudio}
      />
      {children}
      {mode === EDITOR_MODE.EDIT && (
        <DragHandle>{() => <DragSquare />}</DragHandle>
      )}
    </FlashcardSideWrapper>
  )
}

export default FlashcardSide
